import CloseIcon from "@/assets/images/icons/close.svg?inline";

import UploaderIdentityDocuments from "@/components/UploaderIdentityDocuments";
import Field from "./Field";

import {
  CLAIMED_PROPERTY_EDIT_FORM,
  UPDATE_CLAIMED_HOME
} from "../../gql/PropertyQueries";

export default {
  name: "edit_modal",

  data() {
    return {
      isShowModal: false,
      loadingEditedProperty: false,
      isMainTabActive: true,

      skipEditFormQuery: true,
      claimedPropertyEditForm: {}
    };
  },

  props: {
    property: {
      type: Object,
      default: () => {}
    }
  },

  apollo: {
    claimedPropertyEditForm: {
      query: CLAIMED_PROPERTY_EDIT_FORM,
      variables() {
        return {
          propertyId: this.property.mainInfo.id
        };
      },

      skip() {
        return this.skipEditFormQuery;
      },

      result() {
        this.skipEditFormQuery = false;
      }
    }
  },

  methods: {
    showModal() {
      if (!this.claimedPropertyEditForm.data) {
        this.skipEditFormQuery = false;
      }

      this.$refs.modalEdit.show();
    },

    hideModal() {
      this.$refs.modalEdit.hide();
    },

    resetModal() {
      this.isMainTabActive = true;
    },

    saveEditedProperty() {
      this.loadingEditedProperty = true;

      let params = {};

      for (let i in this.claimedPropertyEditForm.data) {
        let inputs = this.claimedPropertyEditForm.data[i].inputs;

        for (let j in inputs) {
          if (inputs[j].type === "integer") {
            params[inputs[j].name] = parseInt(inputs[j].value);
          } else if (inputs[j].type === "float") {
            params[inputs[j].name] = parseFloat(inputs[j].value);
          }
          else {
            params[inputs[j].name] = inputs[j].value;
          }
        }
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_CLAIMED_HOME,
          variables: {
            id: this.property.mainInfo.id,
            propertyParams: params
          }
        })
        .then(({ data }) => {
          this.hideModal();
          this.$toasted.success(
            "Your changes will be available after approval within next 24 hours"
          );

          this.property.haveClaimedPropertyUpdates = true;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.loadingEditedProperty = false;
        });
    }

  },

  components: {
    CloseIcon,
    UploaderIdentityDocuments,
    Field
  }
};
